import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './icons';
import { isAdmin, canOperate } from '../lib/roles';

const ADMIN_SECTIONS = [
  {
    label: 'Overview',
    links: [
      ['/dashboard', 'Dashboard', true, 'dashboard'],
      ['/users', 'Users', false, 'customers'],
    ],
  },
  {
    label: '1. Skill Catalog',
    links: [
      ['/skills', 'Skills', false, 'skills'],
      ['/packages', 'Packages', false, 'packages'],
      ['/suites', 'Suites', false, 'suites'],
      ['/overlays', 'Overlays', false, 'overlays'],
    ],
  },
  {
    label: '2. Tenants & Billing',
    links: [
      ['/signups', 'Plan Signups', false, 'approvals'],
      ['/customers', 'Customers', false, 'customers'],
      ['/workspaces', 'Workspaces', false, 'workspaces'],
      ['/entitlements', 'Entitlements', false, 'entitlements'],
      ['/credit-pools', 'Credit Pools', false, 'creditPools'],
    ],
  },
  {
    label: '3. Agents & Task Lifecycle',
    links: [
      ['/goals', 'Goals', false, 'goals'],
      ['/agents', 'Agents', false, 'agents'],
      ['/tasks', 'Tasks', false, 'tasks'],
      ['/routing', 'Routing Demo', false, 'routing'],
      ['/runs', 'Runs', false, 'runs'],
      ['/approvals', 'Approvals', false, 'approvals'],
    ],
  },
  {
    label: '4. Integrations & Oversight',
    links: [
      ['/integrations', 'Integrations', false, 'integrations'],
      ['/audit', 'Audit Logs', false, 'audit'],
      ['/reports', 'Reports', false, 'reports'],
    ],
  },
];

const USER_SECTIONS = [
  {
    label: 'Work',
    links: [
      ['/goals', 'Goals', true, 'goals'],
      ['/home', 'Run a skill', false, 'routing'],
      ['/tasks', 'My tasks', false, 'tasks'],
      ['/runs', 'Results', false, 'runs'],
    ],
  },
  {
    label: 'Review',
    links: [['/approvals', 'Approvals', false, 'approvals']],
    operatorOnly: true,
  },
];

export default function Nav() {
  const sections = isAdmin()
    ? ADMIN_SECTIONS
    : USER_SECTIONS.filter((s) => !s.operatorOnly || canOperate());

  return (
    <nav className="app-nav">
      {sections.map((section) => (
        <div className="app-nav__section" key={section.label}>
          <p className="app-nav__section-label">{section.label}</p>
          {section.links.map(([to, label, exact, icon]) => (
            <NavLink
              key={to}
              to={to}
              exact={!!exact}
              className="app-nav__link"
              activeClassName="app-nav__link--active"
            >
              <Icon name={icon} />
              <span>{label}</span>
            </NavLink>
          ))}
        </div>
      ))}
    </nav>
  );
}
